export default "__VITE_ASSET__BflMdfei__"